import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import { Container, Reveal, SectionHead } from "@/components/Motion";
import { IMAGES, INDUSTRIES } from "@/data/content";

export default function Industries() {
  return (
    <>
      <SEO
        title="Industries We Serve | EVOVLEX IT"
        description="EVOVLEX IT supports organizations across banking, healthcare, education, government, manufacturing, retail, startups and professional services with tailored technology solutions."
      />
      <PageHero
        eyebrow="Industries"
        titleLines={[
          "Technology Solutions",
          { node: <span>Across <span className="text-gradient-brand">Industries</span></span> },
        ]}
        sub="EVOVLEX IT supports organizations across diverse industries with technology solutions tailored to their unique requirements."
        image={IMAGES.hero}
      />

      <section data-testid="industries-grid-section" className="bg-white py-20 lg:py-28">
        <Container>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {INDUSTRIES.map((ind, i) => (
              <Reveal key={ind.title} delay={0.05 * (i % 4)} className="h-full">
                <div
                  data-testid={`industry-page-card-${ind.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="group relative h-full overflow-hidden rounded-2xl border border-slate-200 bg-slate-50/60 p-8 transition-all duration-500 hover:-translate-y-1 hover:border-cyan-500/40 hover:bg-white hover:shadow-2xl hover:shadow-blue-600/10"
                >
                  <span className="absolute right-6 top-6 font-mono text-xs font-semibold tracking-widest text-slate-200 transition-colors group-hover:text-cyan-500">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-50 text-evo-blue transition-colors duration-300 group-hover:bg-evo-blue group-hover:text-white">
                    <ind.icon className="h-6 w-6" strokeWidth={1.8} />
                  </span>
                  <h2 className="mt-5 font-display text-lg font-semibold text-slate-900">{ind.title}</h2>
                  <p className="mt-2 text-sm leading-relaxed text-slate-500">{ind.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.15}>
            <div className="mt-16 flex flex-col items-start justify-between gap-6 rounded-2xl border border-slate-200 bg-slate-50 p-8 sm:flex-row sm:items-center lg:p-10">
              <SectionHead eyebrow="Your Industry" title="Don't see your industry listed?" />
              <Link
                to="/contact"
                data-testid="industries-cta-contact"
                className="inline-flex shrink-0 items-center gap-2 rounded-lg bg-gradient-to-r from-blue-600 to-cyan-500 px-6 py-3.5 text-sm font-semibold text-white shadow-lg shadow-blue-600/25 transition-all duration-300 hover:-translate-y-0.5"
              >
                Talk to an Expert
                <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </Reveal>
        </Container>
      </section>
    </>
  );
}
